"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n  text-transform: none;\n  -webkit-appearance: none;\n  border: none;\n\n  &::-webkit-search-cancel-button {\n    -webkit-appearance: none;\n    height: 0.9em;\n    width: 0.9em;\n    background-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='51px' height='51px' stroke-width='2.3' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' color='%23000000'%3E%3Cpath d='M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243' stroke='%23000000' stroke-width='2.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-size: 0.9em;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  border: 0;\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n  background: none;\n  display: block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reset = exports.ResetInput = exports.ResetButton = void 0;

var styledTypes_1 = require("./styledTypes");

exports.ResetButton = styledTypes_1.styled.button(_templateObject());
exports.ResetInput = styledTypes_1.styled.input(_templateObject2());
exports.Reset = {
  Button: exports.ResetButton,
  Input: exports.ResetInput
};